
<template>
    <p class="control">
        <input v-on:change="timeChanges()" v-model.number="weekTime" @keyup.enter="updateRegistration()" class="input is-small" type="number" min=0 max=24 step="0.5" :disabled="this.weekIsApproved" v-bind:class="{ halfWidth: showSaveButton }">
        <input type="submit" :value="$t('input.save')"  v-if="weekTime <= 24 && weekTime >= 0 && showSaveButton" @click="updateRegistration()" class="button is-small is-primary is-outlined is-pulled-right">
        <a v-else-if="weekTime > 24 || weekTime < 0" class="button is-small is-danger is-outlined is-pulled-right" disabled>{{$t("input.error")}}</a>
        {{getRegistratedHours}}
    </p>
</template>

<script>
import firebase from '@/firebase'
import moment from 'moment'
import _ from 'lodash'

export default {
  name: 'TimeWeekInput',
  components: {
    
  },
    props: {
      weekDate: String,
      weekProject: String,
      weekProjectNo: String,
      weekProjectLine: String,
      weekIsApproved: Boolean,
      weekProjectKey: String,
    },
    watch: {
      '$route' (to, from) {
        // when route changes
        const tenantid = JSON.parse(localStorage.getItem('profile')).tenantid;
        firebase.auth().onAuthStateChanged(function(user) {
          if (user) {
            this.user = user
            this.$bindAsArray('allRegistrationsOnSpecificDate', firebase.database().ref('/organisations/' + tenantid + '/registrations/' + user.uid).orderByChild('date').equalTo(this.weekDate));
          }
        }.bind(this))
      },
      /*'weekTime': function(value) {
        console.log("value: ", value)
      } */
    },
      firebase: function() { 
        const tenantid = JSON.parse(localStorage.getItem('profile')).tenantid;
        const userid = JSON.parse(localStorage.getItem('profile')).user_id;
        return {
            allRegistrationsOnSpecificDate: {
              source: firebase.database().ref('/organisations/' + tenantid + '/registrations/' + userid).orderByChild('date').equalTo(this.weekDate),
            },
            orgSettings: {
              source: firebase.database().ref('/organisations/' + tenantid + '/settings'),
              asObject: true,
          },
        }
    },
    data: function() {
      return {
        weekTime: 0,
        allRegistrationsOnSpecificDate: [],
        showSaveButton: false,
      }
    },
    computed: {
      getRegistratedHours: function() {
        // sum all registration on same project
        var sum = 0;
        for (var i = 0, len = this.allRegistrationsOnSpecificDate.length; i < len; ++i) {
          var project = this.allRegistrationsOnSpecificDate[i].projectCombined
            if (project == this.weekProject) {
              sum += this.allRegistrationsOnSpecificDate[i].time
            }
        }
        this.weekTime = sum;
      },
    },
    methods: {
      timeChanges: function() {
        this.showSaveButton = true;
      },
      updateRegistration: function() {
        if (this.weekTime > 0 && this.allRegistrationsOnSpecificDate.length == 1) {
          this.$firebaseRefs.allRegistrationsOnSpecificDate.child(this.weekProjectKey).update({
              time: this.weekTime,
              sentForApproval: false,
              timestamp: moment().format()
          });
          //hide save button
          this.showSaveButton = false;
        } else if (this.weekTime == 0 || this.allRegistrationsOnSpecificDate.length > 1) {
            //multiple registrations on same day - delete all - and push new
            var updates = {};
            for (var i = 0, len = this.allRegistrationsOnSpecificDate.length; i < len; ++i) {
                // add update information to array
                if (this.weekProject == this.allRegistrationsOnSpecificDate[i]['projectCombined']) {
                  updates[this.allRegistrationsOnSpecificDate[i]['.key']] = null;
                }
            }
            if (this.showSaveButton) {
              this.$firebaseRefs.allRegistrationsOnSpecificDate.update(updates).catch(function (err) {
                console.log('one of these updates failed', err)
              });
              this.showSaveButton = false;
            }
            if (this.weekTime > 0) {
              const tenantid = JSON.parse(localStorage.getItem('profile')).tenantid;
              const userid = JSON.parse(localStorage.getItem('profile')).user_id;
              let update = {
                  project: this.weekProjectNo,
                  projectLine: this.weekProjectLine,
                  projectCombined: this.weekProject,
                  uid: userid,
                  tenantid: tenantid,
                  date: this.weekDate,
                  time: this.weekTime,
                  quarter: moment(this.weekDate).quarter(),
                  isApproved: false,
                  sentForApproval: false,
                  timestamp: moment().format()
              }
              if (this.orgSettings.ERPenabled === false) {
                update.isCustomProject = true
              } 
              this.$firebaseRefs.allRegistrationsOnSpecificDate.push(update);
            }
        }
      }
    }
}
</script>